/**
 * Registry único de servicios del frontend.
 *
 * FUENTE DE VERDAD para metadatos de presentación: DOM id, claves i18n, schedulable.
 * Sustituye las 3 definiciones duplicadas que existían en:
 *   - src/js/index.js (arrays is_schedulable, special-case PROBIOMENTOR→service_PROBIO)
 *   - src/js/farmaval.js (serviceTranslations)
 *   - section_services.html (ids de tarjetas)
 *
 * El GRUPO MÉDICO de cada servicio (respiratorio, probioticos…) viene del backend
 * (endpoint GET /v1/services). No se duplica aquí.
 *
 * Para añadir un servicio nuevo:
 *   1. Insertar en la tabla `services` del backend (seeder/SQL) con su grupo.
 *   2. Añadir la entrada aquí con su domId, claves i18n y schedulable.
 *   3. Crear la tarjeta HTML en section_services.html.
 *   4. Si el servicio pertenece a un grupo existente, NO se toca serviceMenus.js.
 *      Si crea un grupo nuevo, declarar su perfil en serviceMenus.js.
 */
export const SERVICES = {
    CEPOC: {
        domId:      'service_CEPOC',
        langName:   'cepoc_name',
        langDesc:   'cepoc_desc',
        schedulable: true,
    },
    SATI: {
        domId:      'service_SATI',
        langName:   'sati_name',
        langDesc:   'sati_desc',
        schedulable: true,
    },
    SATI_TEST: {
        domId:      'service_SATI_TEST',
        langName:   'sati_test_name',
        langDesc:   'sati_test_desc',
        schedulable: true,
    },
    IRETIA: {
        domId:      'service_IRETIA',
        langName:   'iretia_name',
        langDesc:   'iretia_desc',
        schedulable: false,
    },
    PROBIOMENTOR: {
        domId:      'service_PROBIO',    // la tarjeta HTML usa id="service_PROBIO"
        langName:   'probio_name',
        langDesc:   'probio_desc',
        schedulable: false,
    },
}

/**
 * Aliases de código de servicio.
 * PROBIO es el código legado que el backend nuevo renombró a PROBIOMENTOR.
 * Se mantiene aquí por compatibilidad con datos de pharms_services que aún
 * puedan contener el código antiguo.
 */
export const SERVICE_ALIASES = {
    PROBIO: 'PROBIOMENTOR',
}

/**
 * Normaliza un código de servicio resolviendo aliases.
 * @param {string} code
 * @returns {string}
 */
export function normalizeServiceCode(code) {
    return SERVICE_ALIASES[code] || code
}

/**
 * Devuelve el mapa serviceTranslations compatible con translateServices()
 * de farmaval.js (domId → [langName, langDesc]).
 * Así farmaval.js ya no necesita mantener ese objeto a mano.
 */
export function buildServiceTranslationsMap() {
    return Object.fromEntries(
        Object.values(SERVICES).map((s) => [s.domId, [s.langName, s.langDesc]])
    )
}
